<template>
  <div class="page-dictionary-config">
    <crm-panel :title="'角色管理'">
      <div class="mt20 mb20 sub-tools">
        <el-form ref="form" :inline="true">
          <el-form-item label="">
            <el-input
              placeholder="请输入角色名称"
              clearable
              @change="handleSearch({ pageNumber: 1 })"
              v-model.trim="roleName"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="page-buttons">
          <crm-button
            v-if="auth.authorityRoleAdd && auth.authorityRoleAdd.toggleStatus"
            :buttonType="'secondary'"
            :text="'新增角色'"
            @click="addDialog"
          >
          </crm-button>
        </div>
      </div>
      <el-table
        :data="roleList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          label="角色名称"
          align="center"
          width="160"
          prop="name"
        >
        </el-table-column>
        <el-table-column
          label="角色说明"
          align="center"
          width="300"
          prop="note"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column prop="creator" align="center" label="创建人">
        </el-table-column>
        <el-table-column prop="gmtCreated" align="center" label="创建时间">
        </el-table-column>
        <el-table-column prop="modifier" align="center" label="更新人">
        </el-table-column>
        <el-table-column prop="gmtModified" align="center" label="更新时间">
        </el-table-column>
        <el-table-column align="center" width="300" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="handleEdit(scope)"
              type="text"
              size="small"
              v-if="
                auth.authorityRoleModify &&
                  auth.authorityRoleModify.toggleStatus
              "
              >编辑</el-button
            >
            <el-button
              @click="handleDetail(scope)"
              type="text"
              size="small"
              v-if="
                auth.authorityRoleUserList &&
                  auth.authorityRoleUserList.toggleStatus
              "
              >角色用户</el-button
            >
            <el-button
              @click="handleRole(scope)"
              type="text"
              size="small"
              v-if="auth.roleAuth && auth.roleAuth.toggleStatus"
              >角色权限</el-button
            >
            <el-button
              @click="handleDelete(scope)"
              type="text"
              size="small"
              v-if="auth.authorityRoleDel && auth.authorityRoleDel.toggleStatus"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="roleList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新建角色弹窗 -->
    <edit-role ref="dialogEdit" @refresh="handleRefresh()"> </edit-role>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import editRole from '~component/business/backstage/editRole.vue';
import service from '~api/backstage';

export default {
  components: {
    crmPanel,
    crmButton,
    editRole,
  },
  data() {
    return {
      loading: false,
      roleName: '',
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      roleList: 'backstage/roleList',
      backRolemanage: 'authority/backRolemanage',
      auth: 'authority/auth',
    }),
  },
  created() {
    this.getRoleList(this.page);
  },
  methods: {
    ...mapActions({
      getRoleList: 'backstage/getRoleList',
    }),
    // 新建
    addDialog() {
      this.$refs.dialogEdit.isAddDialogVisible = true;
      this.$refs.dialogEdit.type = 'add';
    },
    handleSearch(page) {
      if (page) this.page.pageNumber = page?.pageNumber;
      this.getRoleList({
        ...this.page,
        pageNumber: (page && page.pageNumber) || this.page.pageNumber,
        roleName: this.roleName,
      });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;
      this.handleSearch();
    },
    handlePageChange(index) {
      this.page.pageNumber = index;
      this.handleSearch();
    },
    handleRefresh() {
      this.handleSearch();
    },
    handleEdit(scope) {
      this.$refs.dialogEdit.info = {
        note: scope.row.note,
        name: scope.row.name,
        roleId: scope.row.roleId,
      };
      this.$refs.dialogEdit.isAddDialogVisible = true;
      this.$refs.dialogEdit.type = 'edit';
    },
    handleDelete(scope) {
      this.$confirm(
        `该操作将删除角色【${scope.row.name}】,且会同步移除已授权用户的角色权限，是否继续当前操作？`,
      ).then(() => {
        service
          .apiDelRole({
            roleId: scope.row.roleId,
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功',
            });
            this.handleSearch();
          });
      });
    },
    // 角色用户
    handleDetail(scope) {
      this.$router.push({
        name: 'roleUserList',
        query: {
          roleId: scope.row.roleId,
          name: scope.row.name,
        },
      });
    },
    // 角色权限
    handleRole(scope) {
      this.$router.push({
        name: 'authList',
        query: {
          roleId: scope.row.roleId,
          name: scope.row.name,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';

.page-dictionary-config {
  display: flex;
  flex: 1;
  width: 100%;
  .dialog-body {
    padding-right: 40px;
  }
}
.sub-tools {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /deep/ .el-form--inline .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
